import React from 'react';
import styled from '@emotion/styled';
import Script from 'next/script';
import { NextSeo } from 'next-seo';

import HelpLayout from 'layouts/Help/HelpLayout';
import staticPage from 'lib/next/staticPage';

const Article = styled.article`
  width: 100% !important;
  margin: 0 auto;
`;

const PrivacyPolicy = () => (
  <HelpLayout title="Privacy Policy">
    <NextSeo title="Privacy Policy" />
    <Article>
      <div name="termly-embed" data-id="b0c943fc-f3b5-4110-a75c-393059428fb4" data-type="iframe"></div>
      <Script
        id="termly-privacy"
        dangerouslySetInnerHTML={{
          __html: `(function(d, s, id) {var js, tjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) return;js = d.createElement(s); js.id = id;js.src = "https://app.termly.io/embed-policy.min.js";tjs.parentNode.insertBefore(js, tjs);}(document, 'script', 'termly-jssdk'));`,
        }}
      />
    </Article>
  </HelpLayout>
);

export default staticPage()(React.memo(PrivacyPolicy));
